import React from 'react';

const NoDataFound = ({ 
    message = "No Data Found", 
    description = "Try adjusting your filters or search criteria.",
    icon = "fa fa-search",
    minHeight = 220 
}) => {
    return (
        <div className="col-12">
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: minHeight, width: '100%' }}>
                <div className="card shadow-sm border-0 p-4 text-center w-100" style={{ background: '#f8fafc' }}>
                    <div style={{ fontSize: 48, color: '#adb5bd', marginBottom: 12 }}>
                        <i className={icon} />
                    </div>
                    <div style={{ fontWeight: 600, fontSize: 20, color: '#495057', marginBottom: 4 }}>
                        {message}
                    </div>
                    <div style={{ color: '#868e96', fontSize: 15 }}>
                        {description}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoDataFound;